import { PRODUCT_TARGET_VALUES } from "@shared/values";
import { CheckboxFilterElement } from "./checkboxFilter.element";

export class AbFilterTargetElement extends CheckboxFilterElement<number> {
  constructor() {
    super({ label: "Livello", eventName: "target-filter-change", optionLabel: (value) => PRODUCT_TARGET_VALUES[value - 1] });
  }
}

export const defineAbFilterTargetElement = () => {
  if (!customElements.get("ab-filter-target")) customElements.define("ab-filter-target", AbFilterTargetElement);
};
